import { Component } from '@angular/core';
import { Router } from '@angular/router';
import { AuthenticationService } from '@core/authentication/services';

@Component({
    selector: 'app-main',
    templateUrl: './main.component.html',
    styleUrls: ['./main.component.scss'],
    standalone: false
})
export class MainComponent {
  userName = this.authenticationService.userName;

  constructor(
    private authenticationService: AuthenticationService,
    private router: Router
  ) { }
  logout(): void {
    this.authenticationService.logout();
  }

  redirectToHomePage() {
    this.router.navigate(['/users']);
  }
}
